import { textLocaleTag } from '../i18n/locale';

// The non-breaking space keeps the percent sign from wrapping onto its own line.
export function formatPercent(value: number | null | undefined, language: string): string {
  const safe = typeof value === 'number' && Number.isFinite(value) ? value : 0;
  const number = new Intl.NumberFormat(textLocaleTag(language), {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(safe);
  return `${number} %`;
}
